import React, { useState, useEffect, forwardRef } from 'react';

import Typography from '@mui/joy/Typography';
import Stack from '@mui/joy/Stack';
import Box from '@mui/joy/Box';
import IconButton from '@mui/joy/IconButton';

///////////// Date Formate
import dateFormat, { masks } from "dateformat";

///////////////////// Modal
import Button from '@mui/joy/Button';
import Modal from '@mui/joy/Modal';
import ModalClose from '@mui/joy/ModalClose';
import SvgIcon from '@mui/joy/SvgIcon';
import ModalDialog from '@mui/joy/ModalDialog';

//////////////// Alert
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';


///////////// Images
import ImageNews from '../../assets/newsImage.png';
import CloseSquareIcon from '../../assets/icons/CloseSquare.svg';


///////////////////// API
import { removeNews } from '../../Api/News';


const Alert = forwardRef(function Alert(props, ref) {
    return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

export default function BloksNews(props) {
    const { listNews, getListNews } = props
    const [openModalConfirm, setOpenModalConfirm] = useState(false)
    const [newsId, setNewsId] = useState(null)
    const [loading, setLoading] = useState(false)
    const [openAlert, setOpenAlert] = useState(false);
    const [messageAlert, setMessageAlert] = useState('');

    const [openAlertError, setOpenAlertError] = useState(false);
    const [messageAlertError, setMessageAlertError] = useState('');


    const handleClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setOpenAlert(false);
    };

    const openConfirmDelete = (id) => {
        setNewsId(id)
        setOpenModalConfirm(true)
    };

    const deleteNews = async () => {
        setLoading(true)
        const res = await removeNews(newsId)
        if(res){
            setLoading(false);
            setMessageAlert("تم حذف الخبر بنجاح")
            setOpenAlert(true)
            setNewsId(null)
            setOpenModalConfirm(false)
            getListNews()
        }
    }


    return (
        <>
            {/* Alert Message */}
            <Snackbar open={openAlert} autoHideDuration={6000} onClose={handleClose}>
                <Alert severity="success">{messageAlert}</Alert>
            </Snackbar>

            {/* Modal PopUp */}
            <Modal open={openModalConfirm} onClose={() => setOpenModalConfirm(false)}>
                <ModalDialog
                    aria-labelledby="nested-modal-title"
                    aria-describedby="nested-modal-description"
                    sx={(theme) => ({
                        [theme.breakpoints.only('xs')]: {
                            top: 'unset',
                            bottom: 0,
                            left: 0,
                            right: 0,
                            borderRadius: 0,
                            transform: 'none',
                            maxWidth: 'unset',
                        },
                        direction: 'rtl'
                    })}
                >
                    <Typography id="nested-modal-title" level="h2">
                        هل انت متاكد من حذف الخبر ؟
                    </Typography>
                    <Typography id="nested-modal-description" textColor="text.tertiary">
                        لا يمكن التراجع عن هذا الإجراء. سيؤدي هذا إلى حذف الخبر بشكل دائم وإزالة بياناتك من خوادمنا.
                    </Typography>
                    <Box
                        sx={{
                            mt: 1,
                            display: 'flex',
                            gap: 1,
                            flexDirection: { xs: 'column', sm: 'row-reverse' },
                        }}
                    >
                        <Button variant="solid" color="primary" onClick={() => deleteNews()}>
                            تأكيد
                        </Button>
                        <Button
                            variant="outlined"
                            color="neutral"
                            onClick={() => setOpenModalConfirm(false)}
                        >
                            الغاء
                        </Button>
                    </Box>
                </ModalDialog>
            </Modal>


            <Stack
                sx={{ 
                    marginTop: '50px', 
                    display: 'flex', 
                    flexDirection: 'row', 
                    flexWrap: 'wrap', 
                    gap: '2%',
                    alignItems:'stretch' 
                }}
            >
                {listNews.map((item) => {
                    return (
                        <Box 
                            sx={{ 
                                width: '30% !important', 
                                marginBottom: '20px', 
                                borderRadius: '10px', 
                                position: 'relative' }}
                                onClick={() => openConfirmDelete(item.id)} 
                        >
                            <IconButton variant="plain" sx={{ position: 'absolute', top: '-15px', right: '-15px' }}>
                                <img src={CloseSquareIcon} alt='close icon' />
                            </IconButton>
                            <Box sx={{ width: '100%', height:'150px', overflow: 'hidden', borderRadius: '10px' }}>
                                <img src={item.image} alt='news' width='100%' height='100%' />
                            </Box>
                            <Box sx={{ backgroundColor: '#FFF', padding: '20px 2%', marginTop: '-8px' }}>
                                <Typography level="h2" sx={{ mb: 0.5, color: '#434448', fontSize: '15px' }}>
                                    {item.title}
                                </Typography>
                                <Typography level="p" sx={{ mb: 0.5, color: '#767D7D', fontSize: '12px' }}>
                                {item.created_at ? dateFormat(item.created_at, "yyyy-mm-dd") : 'لا يوجد تاريخ'}
                                </Typography>

                                <Typography level="p" sx={{ mb: 0.5, color: '#434448', fontSize: '12px' }}>
                                    {item.content}
                                </Typography>
                            </Box>
                        </Box>
                    )
                })}
            </Stack>
        </>
    )
}